// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"279":"f64fbf56","481":"f64fbf56","525":"f64fbf56","761":"340d160a"}[chunkId] + ".chunk.css";
};